import merge from 'lodash-es/merge';
import get from 'lodash-es/get';
import getDefaultStyle from '../css/defaultStyle';

export function getDefaultControlStyle(control) {
  const design = get(control,['options','lookAndFeel','controlsDesign'],'classic');
  if (!getDefaultControlStyle[control.designMode]) {
    getDefaultControlStyle[control.designMode]={};
  }

  if (!getDefaultControlStyle[control.designMode][design]) {

    getDefaultControlStyle[control.designMode][design] = {
      normal: merge({}, getDefaultStyle(), {
        position: 'absolute',
        cursor: 'pointer',
        transitionProperty: 'all',
        transitionDuration: '${schemeAnimationDuration}',
        transitionTimingFunction: 'ease',
        transitionDelay: '0s',
        top: '8px',
        left: '8px',
        width: '96px',
        height: '32px',
        margin: '0px',
        display: 'inline-block',
        userSelect: 'none',
        overflow: control.isLayoutMode ? 'visible' : 'hidden',
      }),
      body: {
        normal: merge({}, getDefaultStyle(), {
          pointerEvents: 'none',
          transitionProperty: 'all',
          transitionDuration: '${schemeAnimationDuration}',
          transitionTimingFunction: 'ease',
          transitionDelay: '0s',
          boxSizing: 'border-box',
          // padding: '${schemePaddingTop} ${schemeFontSize}',
          fontSize: '12px',
          fontWeight: 'bold',
          textAlign: 'center',
          backgroundColor: '${schemeBackground}',
          display: 'block',
          borderStyle: 'solid',
          borderColor: '${schemeShade}',
          borderWidth: design=='classic'?'2px':'0px',
          borderRadius: design=='classic'?'8px':'4px',
          boxShadow:design=='classic'?
            '0px 2px 4px rgba(0,0,0,0.4), 0 -12px 20px ${schemeShade} inset,  0 2px 3px #ffffff inset':'4px 4px 4px rgba(0,0,0,0.5)',
          position: 'absolute',
          top: '0px',
          right: '0px',
          bottom: '0px',
          left: '0px',
          width: '100%',
          height: '100%',
          margin: '0px',
          whiteSpace: 'nowrap',
        }),
        focused: {
          borderColor: 'rgba(0,0,0,0.25)',
        },
        hover: {
          backgroundColor: '${schemeBackgroundHover}',
          boxShadow: design=='classic'?
            '0px 2px 2px rgba(0,0,0,0.4), 0 -8px 20px ${schemeShade} inset,  0 2px 3px #ffffff inset':'2px 2px 2px rgba(0,0,0,0.5)',
        },
        active: {
          backgroundColor: '${schemeShade}',
          boxShadow: design=='classic'?
            '0px 2px 2px rgba(0,0,0,0.6), 0 -8px 20px ${schemeShade} inset,  0 2px 3px #ffffff inset':'0px 0px 0px rgba(0,0,0,0.5)',
        },
      },
      hover: {},
      active: {},
      icon: {
        url: '',
        position: 'center',
        size: 'contain',
        normal: merge({}, getDefaultStyle(), {
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: 'url("${iconUrl}")',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: '${iconPosition}',
          backgroundSize: '${iconSize}',
          margin: '4px',
        }),
      },      
      label: {
        normal: merge({}, getDefaultStyle(), {
          position: 'absolute',
          display: 'inline-block',
          transitionProperty: 'all',
          transitionDuration: '${schemeAnimationDuration}',
          transitionTimingFunction: 'ease',
          transitionDelay: '0s',
          padding: '4px 8px',
          backgroundColor: 'transparent',
          color: '${schemeForeground}',
          textAlign: 'center',
          textShadow: design=='classic'?'0 2px 2px ${schemeShade}':'0 0px 4px ${schemeShade}',
          fontFamily: 'monospace',
          whiteSpace: 'nowrap',
          fontSize: '${schemeFontSize}',
          fontWeight: '${schemeFontWeight}',
        }),
        center: {
          left: '50%',
          top: 'calc(50% + 1px)',
          transform: 'translate(-50%, -50%)',
        },
        top: {
          left: '50%',
          top: 0,
          transform: 'translate(-50%, 0)',
        },
        right: {
          right: 0,
          top: 'calc(50% + 1px)',
          transform: 'translate(0, -50%)',
        },
        bottom: {
          left: '50%',
          bottom: 0,
          transform: 'translate(-50%, 0)',
        },
        left: {
          left: 0,
          top: 'calc(50% + 1px)',
          transform: 'translate(0, -50%)',
        },
      },
    };
  }

  return getDefaultControlStyle[control.designMode][design];
}

export function getDefaultControl() {
  if (!getDefaultControl.source) {
    getDefaultControl.source = document.createElement('div');
    getDefaultControl.source.classList.add('controls');
    getDefaultControl.source.innerHTML =
      '<div class="body" tabindex=0><div class="icon"></div><span class="label"></span></div>';
    getDefaultControl.source.setAttribute('tabindex', '0');
  }

  return getDefaultControl.source.cloneNode(true);
}
